var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
const aesjs = require('aes-js');
class Base64 {
    static decode(encoded) {
        return Buffer.from(encoded, 'base64').toString();
    }
    static encode(decoded) {
        return Buffer.from(decoded).toString('base64');
    }
}
export class Crypto {
    static get salt() {
        return 'JavaScriptRocks';
    }
    constructor(key) {
        const KEY_SIZE = 32;
        const DEFAULT_KEY = '1357986420AETUOLJFSWWCBNXVZRYIQD';
        key = key.padStart(KEY_SIZE, DEFAULT_KEY).substring(0, KEY_SIZE);
        const mappedKey = [...key].map((char) => char.codePointAt(0));
        this.controller = () => new aesjs.ModeOfOperation.ctr(mappedKey, new aesjs.Counter(5));
    }
    encrypt(text) {
        // Convert text to bytes
        const bytes = aesjs.utils.utf8.toBytes(Crypto.salt + text);
        // The counter is optional, and if omitted will begin at 1
        const encrypted = this.controller().encrypt(bytes);
        // To print or store the binary data, you may convert it to hex
        return Base64.encode(aesjs.utils.hex.fromBytes(encrypted));
    }
    decrypt(encrypted) {
        // When ready to decrypt the hex string, convert it back to bytes
        const bytes = aesjs.utils.hex.toBytes(Base64.decode(encrypted));
        // The counter mode of operation maintains internal state, so to
        // decrypt a new instance must be instantiated.
        const decrypted = this.controller().decrypt(bytes);
        // Convert our bytes back into text
        const text = aesjs.utils.utf8.fromBytes(decrypted);
        return text.substring(Crypto.salt.length);
    }
}
export const decrypt = (config) => {
    const { developerLogin, developerPassword, developerSecretToken } = config, rest = __rest(config, ["developerLogin", "developerPassword", "developerSecretToken"]);
    let decryted;
    if (developerPassword) {
        decryted = developerPassword;
    }
    else {
        if (developerLogin && developerSecretToken) {
            const crypto = new Crypto(developerLogin);
            decryted = crypto.decrypt(developerSecretToken);
        }
    }
    return Object.assign({}, rest, { developerLogin, developerPassword: decryted });
};
export const encrypt = (config) => {
    const { developerLogin, developerPassword } = config, rest = __rest(config, ["developerLogin", "developerPassword"]);
    let encryted;
    if (developerPassword && developerLogin) {
        const crypto = new Crypto(developerLogin);
        encryted = crypto.encrypt(developerPassword);
    }
    return Object.assign({}, rest, { developerLogin, developerSecretToken: encryted });
};
//# sourceMappingURL=crypto.js.map